import BaseHooks from './base';

export default class extends BaseHooks {}



// WEBPACK FOOTER //
// ./node_modules/@bigcommerce/stencil-utils/src/hooks/cookie.js